import { toast } from "react-toastify";
import fetcher from "../../../lib/fetcher";
import useSWRMutation from "swr/mutation";
import { IUserOtpRequest } from "../../interfaces";

const useAuthUserSingIn = () => {
  async function authUserNumberPhone(
    url: string,
    { arg }: { arg: { phone: string } }
  ) {
    try {
      const data = await fetcher.post<IUserOtpRequest>(url, arg);

      return data.result?.data;
    } catch (error: any) {
      toast.error(`Что-то не так. Проверьте номер. Причина: ${error}`);
      throw new Error(error);
    }
  }

  const { data, error, isMutating, trigger } = useSWRMutation(
    "/auth/sign-in-stricted",
    authUserNumberPhone
  );

  return { data: data, error, isMutating, trigger };
};
export default useAuthUserSingIn;
